/*
	This helper is only for store the oc parameter and utm_source parameter in the cookie,
	please do not add more parameters to the cookie if it is not necessary
 */

import config from 'config'
import { parse } from 'qs'

const setCookie = (cname, cvalue) => {
	document.cookie = `${cname} = ${cvalue};domain=${config.cookieDomain};path=/;`
}

const storeURLParametersToCookie = location => {
	const params = parse(location.search.substr(1))
	if (params.oc) {
		setCookie('oc', params.oc)
	}
	if (params.utm_source) {
		setCookie('utm_source', params.utm_source)
	}
}

export default storeURLParametersToCookie
